import { useFormik } from "formik";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Panel } from "primereact/panel";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import CardSeplag from "../../../components/CardSeplag";

import {
  buscarTiposVinculo,
  buscarVinculoAndPerfil,
  FormVinculo as initForm,
  salvarVinculo,
} from "../../../service/seguranca/usuario";

import { buscarOrgaosNaoExtintos } from "../../../service/Orgao";

import { buscarUnidadesByIdenOrgao } from "../../../service/UnidadeSetorial";

import { buscarCargos } from "../../../service/Cargo";

import {
  detailAlteracaoSucessoPadrao,
  detailCriacaoSucessoPadrao,
  getFormErrorMessage,
  isFormFieldValid,
  printToast,
  summaryAlteracaoSucessoPadrao,
  summaryCriacaoSucessoPadrao,
} from "../../../config/global";
import classNames from "classnames";

const Vinculo = ({ idenPessoa, numrCpf, isPodeEditar }) => {
  const [vinculos, setVinculos] = useState([]);
  const [atualizar, setAtualizar] = useState(true);
  const [statusVinculo, setStatusVinculo] = useState(false);

  const [tiposVinculos, setTiposVinculos] = useState([]);
  const [form, setForm] = useState(initForm);
  const [orgaos, setOrgaos] = useState([]);
  const [unidades, setUnidades] = useState(null);
  const [cargos, setCargos] = useState(null);
  const [dynamicColumns, setDynamicColumns] = useState([]);
  const optionStatus = [{ statVinculo: "ATIVO" }, { statVinculo: "DESLIGADO" }];
  const [statusSelected, setStatusSelected] = useState({ statVinculo: "ATIVO" });

  const location = useLocation();
  let history = useHistory();

  const startDataTable = () => {
    let columns = [];

    if (isPodeEditar || vinculos.length === 0) {
      columns = [
        { field: "numrVinculo", header: "Nº" },
        { field: "orgao.descOrgao", header: "Órgão" },
        { field: "unidade.descUnidade", header: "Unidade" },
        { field: "cargo.descSeap", header: "Categoria" },
        { field: "tipoVinculo.descTipoVinculo", header: "Tipo" },
        { field: "statVinculo", body: actionTemplate, header: "Status" },
        { field: "rowEdit", rowEditor: "rowEditor " },
      ];
    } else {
      columns = [
        { field: "numrVinculo", header: "Nº" },
        { field: "orgao.descOrgao", header: "Órgão" },
        { field: "unidade.descUnidade", header: "Unidade" },
        { field: "cargo.descSeap", header: "Categoria" },
        { field: "tipoVinculo.descTipoVinculo", header: "Tipo" },
        { field: "statVinculo", body: actionTemplate, header: "Status" },
      ];
    }

    setDynamicColumns(
      columns.map((col, i) => {
        if (col.rowEditor) {
          return <Column rowEditor key={col.field} field={col.field} />;
        }

        return <Column header={col.header} body={col.body} key={col.field} field={col.field} />;
      })
    );
  };

  const actionTemplate = (node, rowData) => {
    if (node.statVinculo === "DESLIGADO") {
      return (
        <Button
          type="button"
          className="p-button-warning"
          label="DESLIGADO"
          disabled={!isPodeEditar}
          onClick={() => {
            updateStatusVinculo(node);
          }}
        />
      );
    }

    return (
      <Button
        type="button"
        className="p-button-success p-button p-component"
        label="ATIVO"
        disabled={!isPodeEditar}
        onClick={() => {
          updateStatusVinculo(node);
        }}
      />
    );
  };

  const updateStatusVinculo = async (data) => {
    if (isPodeEditar || vinculos.length === 0) {
      let jsonPost = {
        ...data,
        statVinculo: data.statVinculo === "ATIVO" ? "DESLIGADO" : "ATIVO",
        numrVinculo: data.numrVinculo ? data.numrVinculo : -100 + (vinculos.length + 1),
        numrMatricula:
          data.numrMatricula && data.numrMatricula !== null ? data.numrMatricula : removeMascaraCpf(numrCpf),
        pessoa: { idenPessoa: idenPessoa },
      };

      let summary = data.idenVinculo > 0 ? summaryAlteracaoSucessoPadrao : summaryCriacaoSucessoPadrao;
      let detail = data.idenVinculo > 0 ? detailAlteracaoSucessoPadrao : detailCriacaoSucessoPadrao;
      await salvarVinculo(jsonPost).then((res) => {
        setAtualizar(true);
        printToast({ summary, detail });
      });
    }
  };

  const voltar = () => {
    history.push({ pathname: "/usuarios", state: {} });
  };

  const onChangeOrgao = (e) => {
    setForm({ ...form, orgao: { ...e.value }, unidade: null });
    setUnidades(null);

    if (e.value.idenOrgao) {
      buscarUnidadesByIdenOrgao(e.value.idenOrgao).then((res) => {
        setUnidades(res);
      });
    }
  };

  const onChangeStatus = (e) => {
    setForm({ ...form, statVinculo: e.value.statVinculo });
  };

  const descOrgaoTemplate = (option) => {
    return (
      <div className="country-item">
        <div>{option.siglOrgao !== " " ? option.siglOrgao + " " + option.descOrgao : option.descOrgao}</div>
      </div>
    );
  };

  const onRowEditInit = (e) => {
    if (e.data.orgao.idenOrgao) {
      buscarUnidadesByIdenOrgao(e.data.orgao.idenOrgao).then((res) => {
        setUnidades(res);
      });
    }

    setForm(e.data);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: form,
    validate: (data) => {
      let errors = {};
      if (!data.statVinculo) {
        errors.statVinculo = "Selecione o status do Vinculo";
      }

      return errors;
    },
    onSubmit: async (data) => {
      let jsonPost = {
        ...data,
        numrVinculo: data.numrVinculo ? data.numrVinculo : -100 + (vinculos.length + 1),
        numrMatricula:
          data.numrMatricula && data.numrMatricula !== null ? data.numrMatricula : removeMascaraCpf(numrCpf),
        pessoa: { idenPessoa: idenPessoa },
      };

      let summary = data.idenVinculo > 0 ? summaryAlteracaoSucessoPadrao : summaryCriacaoSucessoPadrao;
      let detail = data.idenVinculo > 0 ? detailAlteracaoSucessoPadrao : detailCriacaoSucessoPadrao;
      await salvarVinculo(jsonPost).then((res) => {
        let v_vinculos = vinculos.filter((item) => item.idenVinculo != res.idenVinculo);
        setVinculos([...v_vinculos, res]);
        setForm(initForm);
        printToast({ summary, detail });
      });
    },
  });

  function removeMascaraCpf(strCpf) {
    return strCpf.replaceAll(".", "").replaceAll("-", "");
  }

  useEffect(() => {
    if (atualizar === true) {
      if (idenPessoa) {
        buscarVinculoAndPerfil(idenPessoa).then((res) => {
          setVinculos(res);
        });

        buscarTiposVinculo().then((res) => {
          setTiposVinculos(res);
        });

        buscarOrgaosNaoExtintos().then((res) => {
          setOrgaos(res);
        });

        buscarCargos().then((res) => {
          setCargos(res);
        });
        startDataTable();
      }
      setAtualizar(false);
    }
    if (vinculos.length > 0) {
      let statVinculo = false;
      vinculos.forEach((vinculo) => {
        if (vinculo.statVinculo === "ATIVO") statVinculo = true;
      });
      setStatusVinculo(statVinculo);
    }
  }, [atualizar]);

  return (
    <>
      <CardSeplag title="Vínculos">
        {(isPodeEditar || vinculos.length === 0 || statusVinculo === false) && (
          <Panel header="Dados do vínculo">
            <form onSubmit={formik.handleSubmit} className="p-grid">
              <div className="p-fluid grid line-height-4">
                <div className="field col-12 md:col-12 ">
                  <span>
                    <label htmlFor="tipovinculo">Tipo Vínculo</label>
                    <Dropdown
                      emptyMessage="Dados não encontrados"
                      options={tiposVinculos}
                      value={formik.values.tipoVinculo}
                      optionLabel="descTipoVinculo"
                      filter
                      showClear
                      filterBy="descTipoVinculo"
                      placeholder="Selecione um tipo de vínculo"
                      onChange={formik.handleChange}
                      id="tipoVinculo"
                      disabled
                      //onChange={e => { buscarSubUnidadesPeloPai(e.value.idenUnidadeExecucao) }}
                    />
                  </span>
                </div>
                <div className="field col-12 md:col-6 ">
                  <span>
                    <label htmlFor="orgao">Órgão/Entidade</label>
                    <Dropdown
                      emptyMessage="Dados não encontrados"
                      options={orgaos}
                      value={formik.values.orgao}
                      optionLabel="descOrgao"
                      showClear
                      filterBy="siglOrgao,descOrgao"
                      placeholder="Selecione um órgão/entidade"
                      itemTemplate={descOrgaoTemplate}
                      onChange={(e) => onChangeOrgao(e)}
                      filter
                      //onChange={e => { buscarSubUnidadesPeloPai(e.value.idenUnidadeExecucao) }}
                    />
                  </span>
                </div>
                <div className="field col-12 md:col-6 ">
                  <span>
                    <label htmlFor="unidade">Unidade</label>
                    <Dropdown
                      emptyMessage="Dados não encontrados"
                      options={unidades}
                      value={formik.values.unidade}
                      optionLabel="descUnidade"
                      filter
                      showClear
                      filterBy="descUnidade"
                      placeholder="Selecione uma unidade"
                      onChange={formik.handleChange}
                      id="unidade"
                      //onChange={e => { buscarSubUnidadesPeloPai(e.value.idenUnidadeExecucao) }}
                    />
                  </span>
                </div>

                <div className="field col-12 md:col-8 ">
                  <span>
                    <label htmlFor="cargo">Cargo</label>
                    <Dropdown
                      emptyMessage="Dados não encontrados"
                      options={cargos}
                      value={formik.values.cargo}
                      optionLabel="descSeapCompleta"
                      filter
                      showClear
                      filterBy="descSeapCompleta"
                      placeholder="Selecione um Cargo"
                      onChange={formik.handleChange}
                      id="cargo"
                    />
                  </span>
                </div>
                <div className="field col-12 md:col-4 ">
                  <span>
                    <label htmlFor="status">Status</label>
                    <Dropdown
                      emptyMessage="Dados não encontrados"
                      options={optionStatus}
                      value={statusSelected}
                      optionLabel="statVinculo"
                      placeholder="Selecione um Status"
                      onChange={(e) => {
                        setStatusSelected(e.value);
                        onChangeStatus(e);
                      }}
                      id="statVinculo"
                      className={"statVinculo " + classNames({ "p-invalid": isFormFieldValid("statVinculo", formik) })}
                    />
                  </span>
                  {getFormErrorMessage("statVinculo", formik)}
                </div>
              </div>
              <div className="p-fluid grid">
                <div className="field col-12 md:col-8 ">&nbsp;</div>
                <div className="field col-12 md:col-2 ">
                  <Button type="button" className="p-button-secondary" onClick={voltar}>
                    <span className="pi pi-arrow-left p-button-icon p-button-icon-left"></span>
                    <span className="p-button-label">Voltar </span>
                  </Button>
                </div>
                <div className="field col-12 md:col-2 ">
                  <Button
                    label="Salvar"
                    icon={"pi pi-check"}
                    autoFocus
                    className="p-button-success"
                    disabled={!isPodeEditar && vinculos.length > 0 && !statusVinculo === false}
                    type="submit"
                  />
                </div>
              </div>
            </form>
          </Panel>
        )}

        <DataTable
          emptyMessage="Dados não encontrados"
          header="Vinculos"
          value={vinculos}
          showGridlines
          responsiveLayout="scroll"
          editMode="row"
          dataKey="idenVinculo"
          onRowEditInit={onRowEditInit}
        >
          {dynamicColumns}
        </DataTable>
      </CardSeplag>
    </>
  );
};

export default Vinculo;
